module.exports = __webpack_public_path__ + "static/img/aluminum-ingot_256.7999ab1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aluminum-ingot_256.png
// module id = tFZ/
// module chunks = 0